import React, {
	Component
} from 'react';
import * as Common from '../helpers/Common';
import { domainUrl } from '../config/Config';
import RecordPlayer from '../lr_dlr_components/grid_partials/RecordPlayer';
const $ = window.$;
const jQuery = window.jQuery;
export default class Rqulinks extends Component {
	constructor(props) {
		super(props);
		this.state = {
			message: Common.getUserData("No_msg", true)
		};
	}
	fnqlinksSlide1(e) {
		//console.log(e.target);
		if ($(e.target).parent().hasClass('opened')) {
			$(e.target).parent().removeClass('opened');
		} else {
			$('aside').each(function() {
				$(this).removeClass('opened');
			});
			$(e.target).parent().addClass('opened');
		}
	}
	switchPanel(type) {
		let corpCode = Common.getUserData('corpCode', true);
		if (corpCode == 'Dem') {
			return false;
		} else {
			this.props.switchPanel(type);
		}
	}
	getStatus(e) {
		let status = e.target.value;
		let learnerID = Common.getUserData("id", true);
		this.props.setStatusUpdate(status);
		fetch(domainUrl + 'user/buddystatus', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + Common.getTokenData()
			},
			body: JSON.stringify({
				learner_id: learnerID,
				status: status
			})
		}).then((response) => response.json()).then((responseJson) => {
			if (responseJson.status != 0) {
				Common.setUserData("statusBuddyChat", responseJson.bstatus, true);
				Common.downTabClose();
			}
		});
	}
	updateMessage(new_msg) {
		if (new_msg != '') {
			this.setState({
				message: new_msg
			})
		}
	}
	componentDidMount() {
		if(Common.getUserData('todayschuduledlr', true)!=false)
		{
			setTimeout(() => {
				$(".slide6").addClass("opened");
				
			}, 2000);
		}
	}
	render() {
		// let messages = this.state.message;
		// let lib_count = Common.getUserData("count_lib", true);
		// let opinion_polls_count = (Common.getUserData("opinion_polls_count", true)!=false)? Common.getUserData("opinion_polls_count", true):0;
		let chat = Common.getUserData("chat", true);
		let mentor = Common.getUserData("mentor", true);
		let snappoll = Common.getUserData('snapPollReport', true);
		let memberChat = Common.getUserData('memberChat', true);
		let teleCall = Common.getUserData('teleCall', true);
		let library = Common.getUserData('library', true);
		let blog = Common.getUserData('blog', true);
		let collabrate = Common.getUserData('collabrate', true);
		let radio = Common.getUserData('radio', true);
		let poll = Common.getUserData('poll', true);
		let forum = Common.getUserData('forum', true);
		let productID = Common.getUserData('productID', true);
		let recorder = Common.getUserData('recorder', true);
		let corporateID = Common.getUserData('corporateID', true);
		let courseware_count = Common.getUserData('courseware_count', true);
		let corp_array = ['33', '36', '44', '45', '51', '52'];
		let completedStatus = (Common.getUserData("completedStatus", true) != false) ? Common.getUserData("completedStatus", true) : 0;
		let corpCode = Common.getUserData('corpCode', true);
		let title_course = '';
		let todayschuduledlr= (Common.getUserData('todayschuduledlr', true)!=false) ? Common.getUserData('todayschuduledlr', true) : 0;

	
		if (jQuery.inArray(corporateID, corp_array) >= 0) {
			title_course = 'Reference Material';
		} else {
			title_course = 'Courseware';
		}

		let productid = Common.getUserData('productID', true);

		return (<div id="qlinks1">
	


         {(radio != false)?
            <a className="slide-out slide5" alt="Radio" title="Radio" onClick={e=>this.switchPanel('radio')} href="javascript:void(0)">.</a>

				:''}
			
	
			{(todayschuduledlr!=0)?
       <aside className="slide-out slide6"> <a className="recordicon" alt="Today Schedule DLR" title="Today Schedule DLR" onClick={(e)=>this.fnqlinksSlide1(e)}></a>
         <h2>Today Schedule DLR's</h2>
         <div className="recorder-slide vid">
					<ul className="vid-sch">
		{todayschuduledlr.map((item,i) => <li className={((i % 2) == 0) ? 'schduleone' : 'schduletwo' } key={i}><a target="_blank" href={item.url}> DLR - {item.dlrname}<br/></a></li>)}
					</ul>
         </div>
       </aside>
			 :''}

				{(recorder!=false)?
       <aside className="slide-out slide4"> <a className="recordicon" alt="Record Audio and Replay" title="Record Audio and Replay" onClick={(e)=>this.fnqlinksSlide1(e)}></a>
         <h2>Record</h2>
         <div className="recorder-slide">
           {/*<object classID="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0" width="100%" height="175">
             <param name="movie" value="voice_record/Main.swf" />
             <param name="quality" value="high" />
             <param name="wmode" value="transparent"/>
             <embed src="voice_record/Main.swf" wmode="transparent" quality="high" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="100%" height="175"></embed>
    </object>*/}
    <RecordPlayer/>
         </div>
       </aside>
			 :''}
       <aside className="slide-out support"> 
       {(corporateID!=77) ?
       <a className="support-ico  " alt="Learning Records" title="Learning Records" onClick={(e)=>this.fnqlinksSlide1(e)}></a> : '' }
         <h2>Learning Records</h2>
         <img alt="" className="rightslide-img" src={process.env.PUBLIC_URL+'/images/learning-record-img.jpg'}/>
		 <ul className="leftul">
		 {(productID!=359 && productID!=358 && productID!=230 && productID!=248 ) ? 
           <li><a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can review your learning journey in the program as of current date. \nSorry, access to this link is restricted for this demo.');"} onClick={(radio != false)?e=>this.switchPanel('my_journey_demo'):e=>this.switchPanel('my_journey')} title="You can review your learning journey in the program as of current date.">My Journey</a></li> : '' }

 {(productID!=230) ? 
					 <li><a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.\nSorry, access to this link is restricted for this demo.');"} onClick={(radio != false)?e=>this.switchPanel('my_performance_demo'):e=>this.switchPanel('my_performance')} title="You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.">My Performance</a></li> : '' } 
					 
					 {(productid!=418 && productid!=419) ? 
           <li><a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('This is your personal Diary that contains all your notes and all the work you have done inside Learning Room. \nSorry, access to this link is restricted for this demo.');"} onClick={e=>this.switchPanel('my_diary')} title="This is your personal Diary that contains all your notes and all the work you have done inside Learning Room.">My Diary</a></li>
					 : ''}
         </ul>
         <ul className="rightul">
				 {(productid!=418 && productid!=419) ? 
           <li><a  href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now. \nSorry, access to this link is restricted for this demo.');"} onClick={e=>this.switchPanel('recap')} title="When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now.">Recap</a></li>
					 : ''}
					 
           <li><a onClick={e=>this.switchPanel('login_history')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('View the number of times you logged in, at what times of the day, between any two dates… use it as a tool for “proactive planning”. \nSorry, access to this link is restricted for this demo.');"} title='View the number of times you logged in, at what times of the day, between any two dates? use it as a tool for ?proactive planning?.'>Login History</a></li>
         </ul>
       </aside>
			   {/* {(productid!=418 && productid!=419) ? 
			 <aside className="slide-out support"> <a className="support-ico" alt="Learning Records" title="Learning Records" onClick={(e)=>this.fnqlinksSlide1(e)}></a>
         <h2>My Performance</h2>
         <img alt="" className="rightslide-img" src={process.env.PUBLIC_URL+'/images/learning-record-img.jpg'}/>
				 <ul className="leftul">
				 
				 <li><a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.\nSorry, access to this link is restricted for this demo.');"} onClick={(radio != false)?e=>this.switchPanel('my_performance_demo'):e=>this.switchPanel('my_performance')} title="You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.">My Performance</a></li>

				 </ul>
				 </aside>
				 : ''}   */}

       <aside className="slide-out slide1"> 
       {(corporateID!=77) ?
       	<a className="handle1 " alt="Personal Interactions" title="Personal Interactions" onClick={(e)=>this.fnqlinksSlide1(e)}></a> : ''}
         <h2>Personal Interactions</h2>
         <img alt="" className="rightslide-img" src={process.env.PUBLIC_URL+'/images/personal-tntraction-img.jpg'}/>
         <ul className="leftul">
					 {(mentor!= false)?<li><a onClick={e=>this.switchPanel('Observers')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('Observers are people known to you, who would observe you during the course of program, and give you feedback. \nSorry, access to this link is restricted for this demo.');"} title="Observers are people known to you, who would observe you during the course of program, and give you feedback.">My Observers</a></li>:''}
					 
					 {(completedStatus==0 && productid!=418 && productid!=419)?<li><a onClick={e=>this.switchPanel('ecoach')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('Send questions to your E Coach, view the E Coach’s feedback on your work, rate the E Coach’s feedback, and dig into the FAQs pool. \nSorry, access to this link is restricted for this demo.');"} title="Send questions to your E Coach, view the E Coach?s feedback on your work, rate the E Coach?s feedback, and dig into the FAQs pool.">Ask E Coach</a></li>:''}
					 {(productid!=418 && productid!=419) ?
					 <li><a onClick={e=>this.switchPanel('messages')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('This is your personal Message box. You can send and receive messages from your Observers and E Coach. \nSorry, access to this link is restricted for this demo.');"} title="This is your personal Message box. You can send and receive messages from your Observers and E Coach.">Messages </a></li>
					 : '' }
					 {/*(<span>{(!this.state.message)?0:this.state.message}</span>)*/}
           {(completedStatus==0 && chat != false)?<li><a onClick={e=>this.switchPanel('chat_request')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can request for a chat with your E Coach. \nSorry, access to this link is restricted for this demo.');"}  title="You can request for a chat with your E Coach.">E Coach Chat Request</a></li>:''}
         </ul>
         <ul className="rightul">
          {(completedStatus==0 && memberChat != false)?
           <li>
             <div style={{display:'block',border:'1px solid #f3f8fe'}}>
               {(corpCode=='Dem')?<div id="buddyDemLinkdiv" style={{display:'block'}}><a href="javascript:alert('You can view currently logged in program batch mates, and chat with them. \nSorry, access to this link is restricted for this demo.');" style={{float:'left'}} id="buddychat" name="buddychat">Buddy Chat</a></div>:
               <div id="buddyLinkdiv" style={{display:'block'}}> <a href="#/buddychat" target="_blank" title="You can view currently logged in program batch mates, and chat with them."  style={{float:'left'}}  id="buddychat" name="buddychat">Buddy Chat</a> </div>}
               <form name="statusforms" id="statusforms">
                 <select name="cmbStatus" id="cmbStatus"  style={{fontSize:'11px',width:'70px',padding:'0px',margin:'0 0 0 5px'}} value={this.props.statusBuddyChat} onChange={(e)=>this.getStatus(e)}>
                   <option value="1">Online</option>
                   <option value="2">Busy</option>
                   <option value="0">Invisible</option>
                 </select>
               </form>
             </div>

           </li>:''}
           <li> <a onClick={e=>this.switchPanel('Techsupport')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can send your technology related queries to our Technology Support Desk, and get your issues resolved. \nSorry, access to this link is restricted for this demo.');"} title="You can send your technology related queries to our Technology Support Desk, and get your issues resolved." style={{display:'block'}}>Technology Support Desk</a></li>
           {(completedStatus==0 && snappoll != false)?<li> <a onClick={e=>this.switchPanel('Seekfeedback')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you. \nSorry, access to this link is restricted for this demo');"} className="snap_polls" title="Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you.">I Seek Feedback </a> </li>:''}
           {(completedStatus==0 && teleCall != false)?<li> <a onClick={e=>this.switchPanel('Telecall')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can request for a tele call from your E Coach. \nSorry, access to this link is restricted for this demo.');"} title="You can request for a tele call from your E Coach."> Telecalls Request </a> </li>:''}
         </ul>
       </aside>
       <aside className="slide-out slide2"> 
       {(corporateID!=77) ?
       	<a className="handle1 " alt="Learning Resources" title="Learning Resources" onClick={(e)=>this.fnqlinksSlide1(e)}></a> : ''}
         <h2>Learning Resources</h2>
         <img alt="" className="rightslide-img" src={process.env.PUBLIC_URL+'/images/learning-resource-img.jpg'}/>
         <ul className="leftul">
           {(library != false)?<li> <a onClick={e=>this.switchPanel('library')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can Read through, Refer to, and Download relevant material, like articles, research papers in the library. \nSorry, access to this link is restricted for this demo.');"} title="You can Read through, Refer to, and Download relevant material, like articles, research papers in the library.">Library</a> </li>:''}
           {/*<li> <a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('During the program, you will come across many useful diagnostic tests that will help you know yourself better and better. \nSorry, access to this link is
restricted for this demo.');"} title="During the program, you will come across many useful diagnostic tests that will help you know yourself better and better.">Diagnostics</a> </li><span>{'('+lib_count+')'}</span>*/}
         </ul>
         <ul className="rightul">
           {(productID != '' && courseware_count > 0)?<li> <a onClick={e=>this.switchPanel('courseware')} href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You can . \nSorry, access to this link is restricted for this demo.');"} title="Study material as per the curriculum">{title_course}</a> </li>:''}
         </ul>
       </aside>
       <aside className="slide-out slide3"> 
       {(corporateID!=77) ?
       	<a className="handle1 " alt="Group Interactions" title="Group Interactions" onClick={(e)=>this.fnqlinksSlide1(e)}></a> : ''}
         <h2>Group Interactions</h2>
         <img src={process.env.PUBLIC_URL+'/images/grop-intraction-img.jpg'} align="texttop" alt="" border="0" className="rightslide-img"/>
         <ul className="leftul">
            {/*(blog != false)?<li> <a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('This is an internal blog, which you can actively visit, read your peers’ comments across geographies, and contribute by posting your comments, on various current topics. \nSorry, access to this link is restricted for this demo.');"} target="_blank"  title="This is an internal blog, which you can actively visit, read your peers? comments across geographies, and contribute by posting your comments, on various current topics.">Blog</a> </li>:''*/}
           {(poll != false)?<li> <a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results. \nSorry, access to this link is restricted for this demo.');"} onClick={e=>this.switchPanel('opinion_poll')} title="You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results.">Opinion Polls</a> </li>:''}
           {/* {(poll != false)?<li> <a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results. \nSorry, access to this link is restricted for this demo.');"} onClick={e=>this.switchPanel('collaborate')} title="Collaborate">Collaborate</a> </li>:''} */}
         </ul>
         <ul className="rightul">
           {/*(forum != false)?<li> <a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('This is a Community Discussion Forum, in which you would participate with your other batch mates and E Coaches as part of the program. \nSorry, access to this link is restricted for this demo.');"} className="img_forum" target="_blank" title="This is a Community Discussion Forum, in which you would participate with your other batch mates and E Coaches as part of the program.">Forum</a> </li>:''<span>{'('+opinion_polls_count+')'}</span>*/}
           {(collabrate != false)?<li><a href={(corpCode != 'Dem')?"javascript:void(0);":"javascript:alert('Collabration.');"} onClick={e=>this.switchPanel('collaborate')} title="Collabration.">Collaborate</a></li>:''}
         </ul>
       </aside>
     </div>);
	}
}



// WEBPACK FOOTER //
// ./src/partials/Rqulinks.js